module.exports = __webpack_public_path__ + "img/85.bb89bda9.jpg";